import React, { FC, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, Router, Switch, useHistory } from 'react-router-dom'

import { ModalProvider } from '@root-gipro/context/modal-provider'
import Header from '@root-gipro/modules/header/containers'
import { Notify } from '@root-gipro/modules/notify/Notify'
import { UserArchive } from '@root-gipro/modules/userArchive/containers'
import { CheckPlate } from '@root-gipro/modules/userProjects/components/Project/CheckPlate/CheckPlate'
import { UserProjects } from '@root-gipro/modules/userProjects/containers'
import { history, Routes } from '@root-gipro/router'
import { authorize, fetchPublicInfo } from '@root-gipro/store/actions'
import { IState } from '@root-gipro/store/interfaces/state'

import AdminContainer from '@root-gipro/modules/AdminPanel/AdminContainer'
import TechSolutions from '@root-gipro/modules/userProjects/components/Project/ProjectTechSolutions/TechSolutions'
import { UncTablContainer } from '@root-gipro/modules/userProjects/components/Project/UncTable/UncTablContainer'
import { Parameters, Rates, SelectedContainer } from '@root-gipro/modules/commonProjects/containers/SelectedProject'

import '@root-gipro/styles/index.scss'
import '@root-gipro/modules/admin/styles/Admin.scss'
import '@root-gipro/modules/AdminPanel/styles/adminPanel.scss'
import '@root-gipro/modules/commonProjects/styles/Projects.scss'
import Login from '@root-gipro/modules/auth/components/Auth/Login'
import { ThemeProvider } from '@material-ui/core'
import { theme } from '../modules/auth/styles/mui-theme'
import ProjectRpc from '@root-gipro/modules/userProjects/components/Project/ProjectRpc/ProjectRpc'

const App: FC = () => {

  const roleId = localStorage.getItem('roleId');
	const { isFilterOpen } = useSelector((state: IState) => state.maket)
	const { accessToken } = useSelector((state: IState) => state.auth)
	const dispatch = useDispatch()
	
	useEffect(() => {
		if (accessToken) {
			dispatch(fetchPublicInfo())
	
			if (window.location.pathname === Routes.LOGIN || window.location.pathname === '/') {
				history.push(Routes.USER_PROJECTS)
			}
		}
	}, [accessToken])

	return (
		<Router history={history}>
			<Switch>
				{!accessToken ? (
					<ThemeProvider theme={theme}>
						<Route exact path={Routes.LOGIN} component={Login} />

						<Route path='*'>
							<Redirect to={Routes.LOGIN} />
						</Route>
						<Notify />
					</ThemeProvider>
				) : (
					<>
						<ModalProvider>
							<div className={`wrapper-for-animation ${isFilterOpen && 'is-filter-open'}`}>
								<Header />
								<Switch>
								<Route path={Routes.COMMON_PROJECTS}>
									<Redirect to={Routes.USER_PROJECTS} />
								</Route>
									<Route exact path='/' render={() => <Redirect to={Routes.USER_PROJECTS} />} />
									<Route exact path={Routes.USER_PROJECTS} component={UserProjects} />
									<Route exact path={Routes.USER_ARCHIVE} component={UserArchive} />
									<Route path={Routes.ADMIN} component={AdminContainer} />

									<SelectedContainer>
										<Route exact path={Routes.COMMON_PROJECTS_PARAMETERS} component={Parameters} />
										<Route exact path={Routes.COMMON_PROJECTS_RATES} component={Rates} />
									{/* <Route exact path={Routes.COMMON_PROJECTS_CONSTRUCTION_RESOURCES} component={ConstructionResources} /> */}
										<Route exact path={Routes.USER_PROJECTS_PARAMETERS} component={CheckPlate} />
										<Route exact path={Routes.USER_PROJECTS_RATES} component={UncTablContainer} />
										<Route exact path={Routes.USER_ARCHIVE_PARAMETERS} component={CheckPlate} />
										<Route exact path={Routes.USER_ARCHIVE_RATES} component={UncTablContainer} />
										<Route exact path={Routes.USER_PROJECTS_TECHNICAL_SOLUTIONS} component={TechSolutions} />
										<Route exact path={Routes.USER_ARCHIVE_TECHNICAL_SOLUTIONS} component={TechSolutions} />

                    {roleId && (+roleId <= 3) && (
                      <Route exact path={Routes.USER_PROJECTS_RPC} component={ProjectRpc} />
                    )}
                    
                    {/* Подключение компонента */}
									</SelectedContainer>
									<Route path='*'>
										<Redirect to={Routes.USER_PROJECTS} />
									</Route>
								</Switch>
								<Notify />
							</div>
						</ModalProvider>
					</>
				)}
			</Switch>
		</Router>
	)
}

export default App
